<ion-item lines="none" *ngFor="let option of $any(props.options); let i = index;">
    <ion-label class="ion-text-wrap ion-label-font-sm">{{ option.value }}</ion-label>
    <ion-checkbox mode="md" slot="end" [id]="id + '_' + i" [taFormlyAttributes]="field" [ariaLabel]="option.value"
        [checked]="formControl.value[option.key]" (ionChange)="onChange(option.key, $any($event.target).checked)"
        legacy="true">
    </ion-checkbox>
</ion-item>